import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';

/**
 * /join?email=... (linked from newsletters sent to non-members).
 * Goes to the home page and opens the sign-up form with the email filled in.
 * Page changes close open modals, so the modal opens just after navigation.
 */
export default class JoinRedirect extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    const email = m.route.param('email') || '';
    m.route.set(app.route('index'), {}, {
      replace: true
    });
    if (app.session.user) return;
    setTimeout(() => {
      app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/SignUpModal'), {
        email
      });
    }, 300);
  }
  view() {
    return m("div", null);
  }
}
flarum.reg.add('voucha-newsletter', 'forum/components/JoinRedirect', JoinRedirect);